<div *ngIf="isOpen"
  class="fixed inset-0 bg-black/60 flex justify-center items-center z-[60]"
  (click)="close.emit()">
  <div
    class="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-2xl w-full max-w-lg relative"
    (click)="$event.stopPropagation()">
    <button
      (click)="close.emit()"
      class="absolute top-3 right-3 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300"
      title="Close">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>

    <div class="flex items-start gap-4">
      <div class="flex-shrink-0 h-10 w-10 flex items-center justify-center rounded-full bg-red-100 dark:bg-red-900/40">
        <svg class="w-6 h-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
      </div>

      <div class="flex-1">
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">Confirm Deletion</h3>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">Are you sure you want to delete this chat?</p>
        <p class="text-sm font-medium text-gray-700 dark:text-gray-200 mt-1 truncate">
          {{ title || 'This action cannot be undone.' }}
        </p>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-6">
      <button
        (click)="close.emit()"
        class="px-4 py-2 rounded-lg text-sm font-medium bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700">
        Cancel
      </button>
      <button
        (click)="confirm.emit()"
        class="px-4 py-2 rounded-lg text-sm font-medium bg-red-600 text-white hover:bg-red-700">
        Delete
      </button>
    </div>
  </div>
</div>
